// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class SharedImageService {

//   constructor() { }
// }
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedImageService {
  private imageData: { filename: string; base64: string } | null = null;

  // Store image
  setImage(data: { filename: string; base64: string }) {
    this.imageData = data;
  }

  // Retrieve image
  getImage() {
    return this.imageData;
  }

  // Optional: clear image
  clearImage() {
    this.imageData = null;
  }
}
